import {
  maxWidthContainer,
  maxWidthContainerWithoutGutters,
  minBreakpoints,
  theme,
} from '@noths/polaris-client-ribbons-base';
import { mediaQuery } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import { grid } from 'src/styles/pages.styles';

const { spacing } = theme;

export const listingsLayoutRoot = css`
  ${maxWidthContainerWithoutGutters};

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      ${maxWidthContainer};
    `,
  )};
`;

export const listingLayoutGrid = css`
  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      ${grid};
      padding-top: ${spacing.xl}px;
    `,
  )};
`;

export const listingLayoutGridSeparatingLine = css`
  margin-top: ${spacing.xl}px;
  border-top: 1px solid var(--neutral-black-30);
`;

export const listingsLayoutProducts = css`
  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      grid-column: 4 / span 9;
      order: 2;
    `,
  )}
`;

export const listingsLayoutSidebar = css`
  display: none;

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      display: block;
      grid-column: 1 / span 3;
      order: 1;
    `,
  )}
`;

export const listingsLayoutFooter = css`
  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      grid-column: 4 / span 9;
      order: 2;
    `,
  )}
`;
